export default "__VITE_ASSET___xNnwWIy__"